import { render, staticRenderFns } from "./PivotFieldSelector.vue?vue&type=template&id=6c4a183a&scoped=true"
import script from "./PivotFieldSelector.vue?vue&type=script&lang=js"
export * from "./PivotFieldSelector.vue?vue&type=script&lang=js"
import style0 from "./PivotFieldSelector.vue?vue&type=style&index=0&id=6c4a183a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a183a",
  null
  
)

export default component.exports